import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GA_MEASUREMENT_ID, GtagEventParams } from '../config/google-analytics.config';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private readonly router = inject(Router);
  private readonly measurementId = GA_MEASUREMENT_ID;

  init(): void {
    if (!this.isGtagAvailable()) {
      return;
    }

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.sendPageView(event.urlAfterRedirects);
      });
  }

  event(name: string, params?: GtagEventParams): void {
    if (!this.isGtagAvailable()) {
      return;
    }

    window.gtag!('event', name, params);
  }

  eventClick(label: string): void {
    this.event('click', { event_label: label, event_category: 'engagement' });
  }

  eventConversion(action: string, value?: number): void {
    this.event('conversion', { event_action: action, value });
  }

  eventError(message: string, fatal: boolean = false): void {
    this.event('exception', { description: message, fatal });
  }

  private sendPageView(pagePath: string): void {
    if (!this.isGtagAvailable()) {
      return;
    }

    window.gtag!('config', this.measurementId, {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: typeof document !== 'undefined' ? document.title : ''
    });
  }

  private isGtagAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
  }
}
